module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "switch-demo",
    attrs: {
      "title": "Switch"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "size",
      "description": "尺寸",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('vSwitch', {
    attrs: {
      "size": 'sm'
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }), _vm._v(" "), _c('vSwitch', {
    attrs: {
      "size": 'md'
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }), _vm._v(" "), _c('vSwitch', {
    attrs: {
      "size": 'lg'
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "style",
      "description": "自定义样式",
      "code": _vm.color_code
    },
    slot: "right"
  }, [_c('vSwitch', {
    class: 'green',
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "status",
      "description": "状态",
      "code": _vm.status_code
    },
    slot: "left"
  }, [_c('vSwitch', {
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }), _vm._v(" "), _c('vSwitch', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fbfa2f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Switch.vue
// module id = 673
// module chunks = 0